import {useState, useEffect} from "react";
import PropTypes from 'prop-types';


export const Responsive = ({ minWidth, maxWidth, children }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (minWidth === undefined && maxWidth === undefined) {
      return;
    }

    const minWidthQuery = `(min-width: ${minWidth}px)`;
    const maxWidthQuery = `(max-width: ${maxWidth}px)`;

    const getMediaQuery = () => {
      if (minWidth !== undefined && maxWidth !== undefined) {
        return `(${minWidthQuery}) and (${maxWidthQuery})`;
      } else if (minWidth !== undefined) {
        return minWidthQuery;
      } else if (maxWidth !== undefined) {
        return maxWidthQuery;
      }
      return '';
    };

    const mediaQuery = window.matchMedia(getMediaQuery());
    
    const handleChange = () => {
      setIsVisible(mediaQuery.matches);
    };

    handleChange();
    mediaQuery.addEventListener("change", handleChange);

    return () => {
      mediaQuery.removeEventListener("change", handleChange);
    };
  }, [maxWidth, minWidth]);

  return isVisible ? children : null;
}

Responsive.propTypes = {
    minWidth: PropTypes.number,
    maxWidth: PropTypes.number,
    children: PropTypes.children
};